module.exports = __webpack_public_path__ + "images/emoji/confounded.2df9756e5d360a391cf9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/confounded.png
// module id = uDSN
// module chunks = 2